<div *ngIf="showTemplate" class="management-container">
  <router-outlet></router-outlet>
</div>
